// extracted by mini-css-extract-plugin
export default {"live-account__container":"styles_live-account__container__nJSVV"};